import { LabelSmall } from "../../../text_display/main_content_text_styling";
import { InputElementMultilineTextArea } from "../../../text_inputs/main_content_inputs";

export function FormElementBiomaterialsWhich({ changeFunction }) {
  return (
    <>
      <LabelSmall>
        Which Biomaterials Will Be Needed?
      </LabelSmall>
      <InputElementMultilineTextArea
        onChange={
          (event) => {
            changeFunction(event, "biomaterial_which");
          }
        }
      />
    </>
  )
}
